import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IonicModule } from '@ionic/angular';

import { FooterModule, HeaderModule, ModalComprovanteRendaModule } from '@usucampeao/ui-mobile';
import { ComprovanteRendaPageRoutingModule } from './comprovante-renda-assinatura-routing.module';
import { ComprovanteRendaAssinaturaPage } from './comprovante-renda-assinatura.page';


@NgModule({
  imports: [
    // root
    CommonModule,
    IonicModule,

    // route
    ComprovanteRendaPageRoutingModule,

    // components modules
    FooterModule,
    HeaderModule,
    ModalComprovanteRendaModule,
  ],
  providers: [],
  declarations: [
    ComprovanteRendaAssinaturaPage,
    // ContratoAssinaturaTipoFisicoComponent,
  ],
})
export class ComprovanteRendaAssinaturaPageModule { }
